import React, { Component } from 'react';
import './styles.css';

export default class MyJourneyWidget extends Component {
  render() {
    return (
      <div className="journey__widget">
        MyJourneyWidget
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/MyJourneyWidget/MyJourneyWidget.js